<script lang="ts">
    import MultiSelect from 'svelte-multiselect'; // https://github.com/janosh/svelte-multiselect

    // export let items: string[] = [];
    export let items: { id: string; label: string }[] = [];
    // export let selected: string[] = [];
    export let selected: { id: string; label: string }[] = [];
    // export let onChange: (selected: string[]) => void;
    export let onChange: (selected: { id: string; label: string }[]) => void;
    export let onKeyUp: (selected: { id: string; label: string }[]) => void = () => {};
    export let disabled: boolean = false;
    export let placeholder: string = '';
    export let allowUserOptions = false;
    export let maxSelect: number | null = null;
</script>

<div class="multi-select-container">
    <MultiSelect
        bind:selected
        options={items}
        on:add={e => onChange(selected)}
        on:remove={e => onChange(selected)}
        on:removeAll={e => {
            onChange([]);
        }}
        on:keyup={e => {
            let currentValue = e.target?.value ?? '';
            console.log('MultiSelect keydown', currentValue);
            onKeyUp([{ id: currentValue, label: currentValue }]);
        }}
        {placeholder}
        {disabled}
        {maxSelect}
        {allowUserOptions}
        selectedOptionsDraggable={false}
        createOptionMsg={null}
        noMatchingOptionsMsg=""
    />
</div>

<style>
    .multi-select-container {
        position: relative;
        display: flex;
        align-items: center;
        background-color: white;
        min-height: 36px;
        width: 100%;
        border-radius: 10px;
    }

    :global(.multi-select-container .multiselect) {
        border: 2px solid #dfdfdf !important;
        border-radius: 10px !important;
        width: 100% !important;
        padding: 0 0 0 6px !important;
        color: black !important;
        min-height: 36px !important;
        font-family: monospace;
        font-size: 13px;
    }
    :global(.multi-select-container .multiselect > svg) {
        display: none;
    }

    :global(.multi-select-container .selected) {
        border: unset;
        background-color: unset;
    }
</style>
